import { BWIError } from './bwi-error';

export class BWINotPlayable extends BWIError {
    constructor(bwiCode: string | undefined) {
        super(bwiCode);
    }
}
